var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "#100C0C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7874 7.61L8.92494 7.96875L8.82244 8.44375L9.38494 8.5475C9.75244 8.635 9.82494 8.7675 9.74494 9.13375L8.82244 13.4687C8.57994 14.59 8.95369 15.1175 9.83244 15.1175C10.5137 15.1175 11.3049 14.8025 11.6637 14.37L11.7737 13.85C11.5237 14.07 11.1587 14.1575 10.9162 14.1575C10.5724 14.1575 10.4474 13.9163 10.5362 13.4913L11.7874 7.61ZM11.8749 5C11.8749 5.33152 11.7432 5.64946 11.5088 5.88388C11.2744 6.1183 10.9565 6.25 10.6249 6.25C10.2934 6.25 9.97548 6.1183 9.74106 5.88388C9.50664 5.64946 9.37494 5.33152 9.37494 5C9.37494 4.66848 9.50664 4.35054 9.74106 4.11612C9.97548 3.8817 10.2934 3.75 10.6249 3.75C10.9565 3.75 11.2744 3.8817 11.5088 4.11612C11.7432 4.35054 11.8749 4.66848 11.8749 5Z",
    fill: "#100C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.db56b79e0801b3e25f5221c809bb9f97.svg";
export { ForwardRef as ReactComponent };